export function obterListaCTeServicoFormaPagamento() {
  return (
    [
      { label: '0 - Pago', value: 'PAGO' },
      { label: '1 - A Pagar', value: 'APAGAR' },
      { label: '2 - Outros', value: 'OUTROS' },
    ]
  );
}
